import Button from 'components/common/Button';

const ContinueButton = ({
  onContinue,
  disabled,
  submittingText,
  isSubmitting = null,
  disableSubmit = null,
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 mt-6 flex justify-end p-4 bp1:relative bp1:p-0">
      <Button
        type="submit"
        className="btnPrimaryDark w-full"
        onClick={onContinue}
        isSubmitting={isSubmitting || disableSubmit}
        disabled={disabled}
        submittingText={submittingText}
        variation="Pill"
      />
    </div>
  );
};

ContinueButton.propTypes = {
  onContinue: PropTypes.func,
  disabled: PropTypes.bool,
  submittingText: PropTypes.string,
  isSubmitting: PropTypes.bool,
  disableSubmit: PropTypes.bool,
};

export default ContinueButton;
